import React, { useEffect, useRef } from 'react';
import { useBluetooth } from '../../contexts/BluetoothContext';
import BluetoothSetupFlow from './BluetoothSetupFlow';

interface BluetoothSetupFlowWithContextProps {
  onReady?: () => void;
  onCalibrationComplete?: (weight: number, addedWeights: number) => void;
  showReadyStep?: boolean;
  readyButtonText?: string;
  readyDescription?: string;
  testMode?: boolean;
}

const BluetoothSetupFlowWithContext: React.FC<BluetoothSetupFlowWithContextProps> = (props) => {
  const { requireNewCalibration, isCalibrated } = useBluetooth();
  const hasRequestedCalibration = useRef(false);

  // Require new calibration when component mounts (only once)
  useEffect(() => {
    // Only require new calibration if we're not already calibrated and haven't requested it yet
    if (!isCalibrated && !hasRequestedCalibration.current) {
      console.log('BluetoothSetupFlowWithContext: Requiring new calibration for exercise');
      requireNewCalibration();
      hasRequestedCalibration.current = true;
    } else if (isCalibrated) {
      console.log('BluetoothSetupFlowWithContext: Already calibrated, skipping calibration requirement');
    } else {
      console.log('BluetoothSetupFlowWithContext: Calibration already requested, skipping');
    }
  }, []); // Empty dependency array - only run once on mount

  return <BluetoothSetupFlow {...props} />;
};

export default BluetoothSetupFlowWithContext;
